class CustomProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector("[data-carousel-track]");
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;

    this.init();
  }

  init() {
    if (!this.track) return;

    this.prevBtn = this.querySelector(".custom-product-carousel__btn--prev");
    this.nextBtn = this.querySelector(".custom-product-carousel__btn--next");

    if (this.prevBtn) {
      this.prevBtn.addEventListener("click", () => {
        const itemWidth = this.track.querySelector(".custom-product-carousel__item").offsetWidth;
        const gap = parseInt(window.getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: -(itemWidth + gap), behavior: "smooth" });
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener("click", () => {
        const itemWidth = this.track.querySelector(".custom-product-carousel__item").offsetWidth;
        const gap = parseInt(window.getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: itemWidth + gap, behavior: "smooth" });
      });
    }

    // Mouse events for drag-to-scroll on desktop
    this.track.addEventListener("mousedown", (e) => {
      this.isDown = true;
      this.track.classList.add("is-dragging");
      this.startX = e.pageX - this.track.offsetLeft;
      this.scrollLeft = this.track.scrollLeft;
    });

    this.track.addEventListener("mouseleave", () => {
      this.isDown = false;
      this.track.classList.remove("is-dragging");
    });

    this.track.addEventListener("mouseup", () => {
      this.isDown = false;
      this.track.classList.remove("is-dragging");
    });

    this.track.addEventListener("mousemove", (e) => {
      if (!this.isDown) return;
      e.preventDefault();
      const x = e.pageX - this.track.offsetLeft;
      const walk = (x - this.startX) * 2; // Multiplier adjusts scroll speed
      this.track.scrollLeft = this.scrollLeft - walk;
    });

    // Prevent default drag behaviors on links/images to avoid ghosting
    const links = this.track.querySelectorAll("a");
    links.forEach((link) => {
      link.addEventListener("dragstart", (e) => e.preventDefault());
    });
  }
}

if (!customElements.get("custom-product-carousel")) {
  customElements.define("custom-product-carousel", CustomProductCarousel);
}
